import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const PreviewContainer = styled(Box)(({ theme }) => ({
  width: 250,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  overflow: "hidden",
  minHeight: 250,
  maxHeight: 400,
  overflowY: "auto",
}));
